import { Clear } from '@mui/icons-material';
import { Card, ListItem } from '@mui/material';
import Button from '@mui/material/Button';
import { FC } from 'react';
import { ConfigurationVariable } from '@/types/metadata/metadata';
import { VariableRef } from '@/types/variable';
import { isString } from '@/util/typeGuards';
import { valueListUtil } from '@/util/validation/valuelist';
import ConfirmPopover from '@/components/common/ConfirmPopover';
import List from '@/components/common/List';
import ListArrows from '@/components/common/ListArrows';
import { ParamProps } from './ParamRenderer';
import ParamStringInteger from './ParamStringInteger';

const ParamValueList: FC<ParamProps> = (props) => {
  const configuration = props.configuration as ConfigurationVariable;

  const initialValue = valueListUtil().getValue(props.configuration, props.initialValue);

  const removeEntry = (indexToRemove: number, values: (string | VariableRef)[]) => {
    const newInitialValue = values.filter((_, index) => index !== indexToRemove);
    props.onChange([props.configuration.value, newInitialValue]);
  };

  return (
    <Card variant='outlined' sx={{ flexGrow: 1 }}>
      <List
        subheader={configuration.label + (props.configuration.required ? ' *' : '')}
        {...(!!props.errors?.length && {
          subheaderSx: {
            color: 'error.main'
          }
        })}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start'
        }}
      >
        {initialValue &&
          initialValue.map((value, index) => (
            <ListItem key={`valuelist.${index}`}>
              <ParamStringInteger
                {...props}
                configuration={{
                  type: 'variable',
                  value: value && !isString(value) ? value.name : value,
                  label: `Value ${index + 1}`,
                  required: props.configuration.required,
                  subtype: props.configuration?.subtype || 'any'
                }}
                initialValue={value}
                onChange={(...args) => {
                  const newInitialValue = [...initialValue];
                  args.forEach(([, newValue]) => (newInitialValue[index] = newValue as string | VariableRef));
                  props.onChange([props.configuration.value, newInitialValue]);
                }}
              />
              <ListArrows
                data={initialValue}
                index={index}
                onChange={(result) => props.onChange([props.configuration.value, result])}
              />
              <ConfirmPopover
                onConfirm={() => removeEntry(index, initialValue)}
                icon={<Clear />}
                skipConfirm={!value || Object.keys(value).length === 0}
                text={
                  <>
                    Remove <code>{value && !isString(value) ? value.name : value}</code> from list?
                  </>
                }
              />
            </ListItem>
          ))}
        <ListItem>
          <Button
            variant='contained'
            color='primary'
            onClick={() => {
              props.onChange([configuration.value, initialValue ? [...initialValue, {}] : [{}]]);
            }}
          >
            Add
          </Button>
        </ListItem>
      </List>
    </Card>
  );
};

export default ParamValueList;
